import { mobilePaddingX } from '../../theme/mobileLayout'

export const programSectionWrapperSx = {
  width: '100%',
  maxWidth: 1920,
  mx: 'auto',
  px: mobilePaddingX,
  boxSizing: 'border-box',
}

export const programInnerSx = {
  maxWidth: 1520,
  mx: 'auto',
  width: '100%',
}

/** Vertical gap between stacked page sections (Figma 200px → 150px) */
export const programSectionGap = { xs: '80px', md: 12, lg: '150px' }

/** Section bottom / top spacing matching programSectionGap */
export const programSectionSpacing = { xs: '80px', md: 12, lg: '150px' }
